import { Control } from "react-hook-form";

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/_atoms/form";
import { Input } from "@/components/_atoms/input";
import { Textarea } from "@/components/_atoms/textarea";
import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";
import { MunicipalPropertyCreateFormValues } from "@/domain/municipal-property/models/municipal-property-create-form-values";

const MULTILINE_ROW_COUNT = 2;

interface MunicipalPropertyTextFieldProps {
  control: Control<MunicipalPropertyCreateFormValues>;
  name: "name" | "description" | "street" | "houseNumber" | "postalCode" | "city";
  maxLength: number;
  className?: string;
  isMultiline?: boolean;
  autoFocus?: boolean;
}

export function MunicipalPropertyTextField({
  control,
  name,
  maxLength,
  className,
  isMultiline = false,
  autoFocus = false,
}: MunicipalPropertyTextFieldProps) {
  const { t } = useDomainTranslation("municipal-property");

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel>{t(`create.field.${name}`)}</FormLabel>
          <FormControl>
            {isMultiline ? (
              <Textarea {...field} rows={MULTILINE_ROW_COUNT} maxLength={maxLength} />
            ) : (
              <Input {...field} autoFocus={autoFocus} maxLength={maxLength} />
            )}
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
